import { Component, OnChanges, Input, inject } from "@angular/core";

import { ApiService, } from "src/app/api.service";
import { ChartingService } from "src/app/charting.service";
import { DvsChartComponent } from "src/app/shared/dvs-chart/dvs-chart.component";
import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-sensor-detail",
	templateUrl: "./sensor-detail.component.html",
	styleUrls: ["./sensor-detail.component.scss"],
	imports: [DvsChartComponent]
})
export class SensorDetailComponent implements OnChanges {
	private api = inject(ApiService);
	private charting = inject(ChartingService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	component: AssemblyConfig.Shaft;
	@Input()
	raw: APIResults.RawSinglesResult;

	public sampleoptions?: Highcharts.Options;
	public spectrumoptions?: Highcharts.Options;
	public errormessage: string;
	public useorder = false;

	ngOnChanges() {
		this.UpdateChart();
	}

	async UpdateChart() {
		if (this.asset && this.component && this.raw) {
			this.sampleoptions = undefined;
			this.spectrumoptions = undefined;
			this.errormessage = undefined;
			try {
				const result = await this.api.GetSensorVibe(this.asset.asset_id, this.component.id, this.raw.rawid);
				this.sampleoptions = this.charting.SampleDefaults("Samples", "Gs", [
					{ type: "line", name: "Samples", data: result.samples },
				]);
				this.spectrumoptions = this.charting.SpectrumDefaults("Velocity | RMS: " + result.rms.toFixed(3) + ", Peak: " + result.p2p.toFixed(3), "MM/S", [
					{ type: "line", name: "Spectrum", data: result.spectrum },
				], this.useorder);
			} catch (err) {
				this.errormessage = "Unable to load sensor details";
				console.error("Couldn't load sensor vibe");
				console.log(err);
			}
		}
	}

}
